import Vue from "vue";
import Router from "vue-router";
import layout from "../views/layout/layout.vue";

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/",
    component: layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home.vue"),
        moduleName: "首页",
        meta: {
          title: "首页",
          index: 0,
        },
      },
      {
        path: "/association",
        name: "association",
        component: () => import("@/views/solution/associationSolutions.vue"),
        moduleName: "商协会解决方案",
        meta: {
          title: "商协会解决方案",
          index: 1,
        },
      },
      {
        path: "/enterprise",
        name: "enterprise",
        component: () => import("@/views/solution/enterpriseSolutions.vue"),
        moduleName: "企业解决方案",
        meta: {
          title: "企业解决方案",
          index: 1,
        },
      },
      {
        path: "/corporate",
        name: "corporate",
        component: () => import("@/views/solution/corporateIPOSolutions.vue"),
        moduleName: "企业IPO解决方案",
        meta: {
          title: "企业IPO解决方案",
          index: 1,
        },
      },
      {
        path: "/intellectual",
        name: "intellectual",
        component: () => import("@/views/solution/intellectualSolutions.vue"),
        moduleName: "知识产权解决方案",
        meta: {
          title: "知识产权解决方案",
          index: 1,
        },
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/solution/productSolutions.vue"),
        moduleName: "产品研发解决方案",
        meta: {
          title: "产品研发解决方案",
          index: 1,
        },
      },
      {
        path: "/talent",
        name: "talent",
        component: () => import("@/views/solution/talentSolutions.vue"),
        moduleName: "人才解决方案",
        meta: {
          title: "人才解决方案",
          index: 1,
        },
      },
      {
        path: "/talent-manage",
        name: "talentManage",
        component: () => import("@/views/product/talent.vue"),
        moduleName: "产品中心-人才管理系统",
        meta: {
          title: "人才管理系统",
          index: 2,
        },
      },
      {
        path: "/digital",
        name: "digital",
        component: () => import("@/views/product/digital-finance.vue"),
        moduleName: "产品中心-产业数字金融",
        meta: {
          title: "产业数字金融",
          index: 2,
        },
      },
      {
        path: "/industrial",
        name: "industrial",
        component: () => import("@/views/product/Industrial-consulting.vue"),
        moduleName: "产品中心-产业咨询中心",
        meta: {
          title: "产业咨询中心",
          index: 2,
        },
      },
      {
        path: "/metaverse",
        name: "metaverse",
        component: () => import("@/views/product/metaverse.vue"),
        moduleName: "产品中心-元宇宙虚拟世界",
        meta: {
          title: "元宇宙虚拟世界",
          index: 2,
        },
      },
      {
        path: "/cooperation",
        name: "cooperation",
        component: () => import("@/views/cooperation/cooperation.vue"),
        moduleName: "合作入驻",
        meta: {
          title: "合作入驻",
          index: 4,
        },
      },
      {
        path: "/case",
        name: "case",
        component: () => import("@/views/case/customerCases.vue"),
        moduleName: "客户案例",
        meta: {
          title: "客户案例",
          index: 3,
        },
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/about/aboutUs.vue"),
        moduleName: "关于我们",
        meta: {
          title: "关于我们",
          index: 6,
        },
      },
      {
        path: "/ai",
        name: "ai",
        component: () => import("@/views/ai/ai.vue"),
        moduleName: "ai",
        meta: {
          title: "AI",
          index: 7,
        },
      },
      {
        path: "/customer",
        name: "customer",
        component: () => import("@/views/ai/customer.vue"),
        moduleName: "AI客服",
        meta: { title: "AI客服" },
      },
      {
        path: "/info",
        name: "info",
        component: () => import("@/views/info/info.vue"),
        moduleName: "info",
        meta: {
          title: "资讯",
          index: 5,
        },
      },
      {
        path: "/info-detail",
        name: "infoDetail",
        component: () => import("@/views/info/detail.vue"),
        moduleName: "资讯详情",
        meta: {
          title: "资讯",
          index: 5,
        },
      },
    ],
  },
];

const router = new Router({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});
export default router;

//全局路由守卫----初始化的时候被调用，每次路由切换之前被调用
router.beforeEach((to, from, next) => {
  document.title = "融商至之-" + (to.meta.title ? to.meta.title : "");
  next();
});
